import React from "react";
import { getSoPlanningProjects, getSoPlanningUsers, addPlanningTask } from "../../../store/external/soplanning";
// 24/10/2026 : autres intervenants (taches liees SOPlanning) et creation rapide de projet
import { findLinkedTasks, syncLinkedTasks, uniqueUsers, userValue, createProject, makeProjectId, nextProjectColor } from "./planningExtras";
import { getStrValue } from "../../../store/utility";
import Loader from "react-loader-spinner";
import Notification from "../../../components/UI/Widget/Notification";
import { toast } from 'react-toastify';

import {
  FormControl,
  ControlLabel,
  InputGroup,
  Col,
  Button,
  Form,
  Row,
  FormGroup,
} from "react-bootstrap";
import Select from "react-select";
import UploadZone from "../UploadZone";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import './planned.css';
import axios from "axios";

// 23/10/2026 : grille de planning a la place de SOPlanning en iframe
import PlanningGrid from "./PlanningGrid";

export default class ResponseTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPlanningModal: false,
      plannedDate: this.setNowIfNotExists(props.request.predictedAt),
      predictedDate: props.request.predictedAt,
      responseResume: props.request.response,
      interventionDate: props.request.executedAt === null
          ? null
          : moment(props.request.executedAt, "DD/MM/YYYY"),
      request: props.request,
      soPlanningUsers: [],
      soPlanningProjects: [],
      files: [],
      loading: true,
      submit: true,
      notify: false,
      message: "",
      notificationType: null,
      task: {
        title: props.request.requestPlanning ? props.request.requestPlanning.title : props.request.name,
        taskId: props.request.requestPlanning ? props.request.requestPlanning.taskId : null,
        userId: props.request.requestPlanning ? props.request.requestPlanning.userId : null,
        projectId: props.request.requestPlanning ? props.request.requestPlanning.projetId : null,
        creatorId: 'jlouis',
        statusId: 'a_faire',
        startDate: props.request.requestPlanning ? props.request.requestPlanning.dateDebut : this.setNowIfNotExists(props.request.predictedAt),
        endDate: props.request.requestPlanning ? props.request.requestPlanning.dateFin : this.setNowIfNotExists(props.request.predictedAt),
      },
      updateResponse: props.request.predictedAt === null,
      // 24/10/2026 : autres intervenants (taches liees) ; extrasBefore = lecture faite a l'ouverture
      extraUsers: [],
      extrasBefore: null,
      xMsg: null
    };
  }
  //React Lifecycle
  componentDidMount() {
    let users = []
    let projects = []
    let displayPlanningProperties = false;
    axios.all([
      getSoPlanningProjects(),
      getSoPlanningUsers()
    ])
    .then((responseArr) => {
      
      const projectsResponse = responseArr[0]
      if (projectsResponse.status == 200) {
        projects = projectsResponse.data.data
      }
      const usersResponse = responseArr[1]
      if (usersResponse.status == 200) {
        users = usersResponse.data.data
      }
      if (projects.length>0 && users.length == 0) {
        displayPlanningProperties = true
      }
      const soPlanningUsers = users.map(user => {
        return {label: user.name, value: user.id, color: user.color} // 03/11/2026 (registre n° 38) : couleur SOPlanning
      });
      const soPlanningProjects = projects.map(project => {
        return {label: project.name, value: project.id, color: project.color}
      });
      
      this.setState({loading: false, soPlanningProjects, soPlanningUsers})
      this.loadExtras(soPlanningUsers);
    }).catch (error =>{
      console.log(error);
      this.setState({loading: false})
    });
  }
  
  componentWillReceiveProps(nextProps) {
    if (this.props.request !== nextProps.request) {
      let { request, predictedDate, plannedDate, interventionDate, responseResume, updateResponse } = this.state;
      const predictedAt = this.setNullIfNotExistsStr(nextProps.request.predictedAt);

      request = nextProps.request;
      plannedDate = predictedAt;
      interventionDate = predictedAt;
      responseResume = nextProps.request.response;
      updateResponse = predictedDate === null;
      //console.log("nextProps : ", plannedDate)
      this.setState({ request, predictedDate, plannedDate, interventionDate, responseResume, updateResponse });
    }
  }

  /*setNowIfNotExists(m) {
    return m === null ? moment().format("YYYY-MM-DD") : moment(m, 'YYYY-MM-DD');
  }*/

  setNullIfNotExists(m) {
    return m === null ? null : moment(m, 'YYYY-MM-DD');
  }

  setNullIfNotExistsStr(str) {
    return str ? null : moment(str, "DD/MM/YYYY").format("YYYY-MM-DD");
  }

  setNowIfNotExists(str) {
    return str === null ? moment().format("YYYY-MM-DD") : moment(str, "DD/MM/YYYY").format("YYYY-MM-DD");
  }

  // 24/10/2026 : autres intervenants deja lies a la tache de la demande (meme link_id)
  componentWillUnmount() {
    this.unmountedPT = true;
  }

  loadExtras = (users) => {
    const rp = this.props.request.requestPlanning;
    if (!rp || !rp.taskId) { this.setState({ extrasBefore: { ok: true, main: null, linked: [] } }); return; }
    findLinkedTasks(rp).then((b) => {
      if (this.unmountedPT) return;
      const ids = uniqueUsers(b.linked.map((t) => userValue(users, t.user_id)), b.main ? b.main.user_id : rp.userId);
      this.setState({ extrasBefore: b, extraUsers: ids });
    });
  };

  extrasShown = () => uniqueUsers(this.state.extraUsers, this.state.task.userId);

  userLabel = (id) => {
    const u = (this.state.soPlanningUsers || []).find((x) => String(x.value).toLowerCase() === String(id).toLowerCase());
    return u ? u.label : id;
  };

  extraChange = (vals) => {
    const ids = (vals || []).map((v) => (v && v.value !== undefined ? v.value : v));
    this.setState({ extraUsers: uniqueUsers(ids, this.state.task.userId) });
  };

  toggleExtra = (userId) => {
    const { extraUsers, task } = this.state;
    const k = String(userId).toLowerCase();
    if (k === String(task.userId || "").toLowerCase()) return;
    const has = extraUsers.some((u) => String(u).toLowerCase() === k);
    this.setState({ extraUsers: has ? extraUsers.filter((u) => String(u).toLowerCase() !== k) : extraUsers.concat([userId]) });
  };

  newProject = (option) => {
    const name = String((option && option.label) || "").trim();
    if (!name) return;
    const { soPlanningProjects } = this.state;
    const exist = soPlanningProjects.find((p) => String(p.label).trim().toLowerCase() === name.toLowerCase());
    if (exist) { const t0 = this.state.task; t0.projectId = exist.value; this.setState({ task: t0 }); return; }
    if (name.length > 50) { this.setState({ xMsg: { ok: false, t: "Libellé de projet trop long (50 caractères maximum)." } }); return; }
    const id = makeProjectId(name, soPlanningProjects.map((p) => p.value));
    const color = nextProjectColor(soPlanningProjects);
    this.setState({ xMsg: { ok: true, t: "Création du projet « " + name + " »…" } });
    createProject({ id, name, color }).then(() => {
      if (this.unmountedPT) return;
      const t = this.state.task;
      t.projectId = id;
      this.setState({ task: t, soPlanningProjects: this.state.soPlanningProjects.concat([{ label: name, value: id, color }]),
        xMsg: { ok: true, t: "Projet « " + name + " » créé dans le planning (code " + id + ") et choisi." } });
    }).catch((e) => {
      const d = e && e.response && e.response.data;
      this.setState({ xMsg: { ok: false, t: "Création du projet refusée : " + ((d && d.message) || (e && e.message) || "erreur") } });
    });
  };

  //Display Planning
  planningModalHandler = e => {
    e.preventDefault();
    this.setState({
      showPlanningModal: !this.state.showPlanningModal
    });
  };

  // 23/10/2026 : clic dans la grille (intervenant x jour)
  pickFromGrid = (userId, dateStr) => {
    const { task } = this.state;
    // une tache sur plusieurs jours garde sa duree, sinon fin = debut
    const s0 = moment(task["startDate"], "YYYY-MM-DD"), e0 = moment(task["endDate"], "YYYY-MM-DD");
    const nb = (task["startDate"] && task["endDate"] && e0.isValid() && s0.isValid()) ? Math.max(0, e0.diff(s0, "days")) : 0;
    task["userId"] = userId;
    task["startDate"] = dateStr;
    task["endDate"] = moment(dateStr, "YYYY-MM-DD").add(nb, "days").format("YYYY-MM-DD");
    this.setState({ task, plannedDate: dateStr });
  };

  closePlanningModal = () => {
    this.setState({
      showPlanningModal: false
    });
  };

  //Add files
  setFiles = (files) => {
    this.setState({ files: files });
  }

  //Plannification / Réponse
  plannedDateHandler = (event) => {
    const { task } = this.state;
    const selectedDateStr = event.target.value;
    const taskEndDateStr = task["endDate"];
    const taskEndDate = moment(taskEndDateStr, "YYYY-MM-DD");
    const selectedDate = moment(selectedDateStr, "YYYY-MM-DD");
    task["startDate"] = selectedDateStr;
    if (taskEndDate.isBefore(selectedDate)) {
      task["endDate"] = selectedDateStr;
    }
    const plannedDate = selectedDateStr;
    this.setState({
      plannedDate,
      task
    });
  };

  inputResponseChangeHandler = (event) => {
    this.setState({
      responseResume: event.target.value,
    });
  };

  taskSelectChange = (property, option) => {
    const { task } = this.state;
    if (option) {
      task[property] = option.value
    } else {
      task[property] = null;
    }
    this.setState({task})
  }

  taskChange = (property, event) => {
    event.preventDefault()
    let { task, plannedDate } = this.state;
    task[property] = event.target.value;
    //console.log(event.target.value);
    if (property === "startDate") {
      const endDateStr = task["endDate"];
      const endDate = moment(endDateStr, 'YYYY-MM-DD');
      const startDate = moment(task[property], 'YYYY-MM-DD');
      if (startDate.isAfter(endDate)) {
        task["endDate"] = event.target.value
      }
      plannedDate = event.target.value
    }
    this.setState({plannedDate, task})
  }

  validateResponse = () => {
    const { updateResponse, submit, task } = this.state;
    
    return  updateResponse && submit && 
            task.userId && task.projectId && 
            task.startDate && task.statusId;
  };

  updateDateHandler = (event) => {
    event.preventDefault();
    var _updateResponse = !this.state.updateResponse;
    this.setState({ updateResponse: _updateResponse });
  };

  predictRequestHandler = (event) => {
    event.preventDefault();
    this.setState({submit: false})
    const { request, responseResume } = this.state;
    let { plannedDate, task } = this.state;
    if (null === plannedDate) {
      plannedDate = moment().format('YYYY-MM-DD');
    }
    const req = {
      id: request.id,
      predictedAt: moment(plannedDate, 'YYYY-MM-DD').format("DD/MM/YYYY"),
      response: responseResume,
      status: 3,
    };
    //console.log(task);
    //console.log(request);
    
    const { files } = this.state;
    
    // 24/10/2026 : taches liees des autres intervenants relues avant, puis creees / deplacees / retirees
    // apres la tache principale (rien n'est retire si la lecture faite a l'ouverture avait echoue)
    const extrasWanted = uniqueUsers(this.state.extraUsers, task.userId);
    const readOk = !!(this.state.extrasBefore && this.state.extrasBefore.ok);
    findLinkedTasks(request.requestPlanning).then((before) => {
      before.ok = before.ok && readOk;
      return addPlanningTask(task).then((response) => {
        if (!response || response.status != 200 || !response.data || !response.data.data) return response;
        if (!extrasWanted.length && !before.linked.length) return response;
        return syncLinkedTasks(response.data.data, before, extrasWanted, task).then((fails) => {
          if (!this.unmountedPT) this.setState({ xMsg: fails.length
            ? { ok: false, t: "Planification faite, mais autres intervenants incomplets : " + fails.join(", ") + ". Vérifier dans le planning." }
            : { ok: true, t: extrasWanted.length ? "Autres intervenants au planning : " + extrasWanted.map(this.userLabel).join(", ") + "." : "Autres intervenants retirés du planning." } });
          return response;
        });
      });
    }).then((response) => {
      if (response.status == 200) {
        const responseData = response.data.data;
        let requestPlanning = request.requestPlanning || {
          taskId: responseData.task_id,
          title: responseData.title,
          userId: responseData.user_id,
          projetId: responseData.project_id,
          dateDebut: responseData.start_date,
          dateFin: responseData.end_date
        }
        requestPlanning["taskId"] = parseInt(responseData.task_id);
        requestPlanning["title"] = responseData.title;
        requestPlanning["userId"] = responseData.user_id;
        requestPlanning["projetId"] = responseData.project_id;
        requestPlanning["dateDebut"] = responseData.start_date;
        requestPlanning["dateFin"] = responseData.end_date;

        req["requestPlanning"] = requestPlanning;

        this.setState({
          notify: true,
          message: "Plannification de la tâche réussie",
          notificationType: toast.TYPE.SUCCESS
        });
        this.props.updResponse(req, files);
        
      } else {
        this.setState({
          notify: true,
          message: "Problème pour affecter la tâche au planning",
          notificationType: toast.TYPE.ERROR
        });
      }
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        notify: true,
        message: "Problème : " + error,
        notificationType: toast.TYPE.ERROR
      });
    })
    this.setState({submit: true})
    
  };

  

  render() {
    const { canUpdate } = this.props;
    const { interventionDate, showPlanningModal, request, plannedDate, 
      updateResponse, task, loading, soPlanningProjects, soPlanningUsers,
      notify, message, notificationType } = this.state;
    
    if (loading) {
      return (<div align="center">
        <Loader type="ThreeDots" color="#00BFFF" height="100" width="100" />
      </div>)
    }

    return (
      <Form>
        <Row style={{ marginBottom: '1rem' }}>
          <Col sm={5}>
            {request.predictedAt === null ? (
              <React.Fragment>
                <InputGroup>
                  <InputGroup.Addon>Plannifiée le</InputGroup.Addon>
                  <FormControl
                    type="date"
                    value={plannedDate}
                    onChange={(event) => this.plannedDateHandler(event)}
                    className="form-control"
                  />
                  <InputGroup.Addon>
                    <span className="fa fa-calendar" />
                  </InputGroup.Addon>
                </InputGroup>
              </React.Fragment>
            ) : !updateResponse ? (
              <React.Fragment>
                <InputGroup>
                  <InputGroup.Addon>Plannifiée le</InputGroup.Addon>
                  <FormControl
                    type="text"
                    value={getStrValue(request.predictedAt)}
                    className="form-control"
                    disabled
                  />
                  {canUpdate ? (
                    <InputGroup.Addon>
                      <span
                        className="fa fa-edit"
                        style={{ cursor: "pointer" }}
                        onClick={(event) => this.updateDateHandler(event)}
                      />
                    </InputGroup.Addon>  
                  ) : null}
                </InputGroup>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <InputGroup>
                  <InputGroup.Addon>Plannifiée le</InputGroup.Addon>
                  <FormControl
                    type="date"
                    value={plannedDate}
                    onChange={(event) => this.plannedDateHandler(event)}
                    className="form-control"
                  />
                  <InputGroup.Addon>
                    <span
                      className="fa fa-ban"
                      style={{ cursor: "pointer" }}
                      onClick={(event) => this.updateDateHandler(event)}
                    />
                  </InputGroup.Addon>
                </InputGroup>
              </React.Fragment>
            )}
          </Col>
          {request.predictedAt !== null && !updateResponse ? (
            <Col sm={5}> 
              <InputGroup>
                  <InputGroup.Addon>Intervenant</InputGroup.Addon>
                  <FormControl
                    type="text"
                    value={task.userId}
                    className="form-control"
                    disabled
                  />
              </InputGroup>
            </Col>
            
          ) : ""}
          
          <Col sm={request.predictedAt !== null && !updateResponse ? 2 : 7}>
            {request.predictedAt !== null && !updateResponse ? (
              <Button bsClass="btn btn-primary" style={{ float: 'right' }} onClick={e => this.planningModalHandler(e)}>{showPlanningModal ? "Masquer planning" : "Ouvrir planning"}</Button>
            ) : null}
          </Col>
        </Row>
        {request.predictedAt !== null && !updateResponse && this.extrasShown().length ? (
          <Row style={{ marginBottom: '1rem' }}>
            <Col sm={12}>
              <span className="text-muted">Autres intervenants : </span><b>{this.extrasShown().map(this.userLabel).join(", ")}</b>
            </Col>
          </Row>
        ) : null}
        {request.predictedAt === null || updateResponse ? (
          <div className="form-horizontal">
            <FormGroup>
              <Col sm={2} componentClass={ControlLabel}>Titre:</Col>
              <Col sm={10}><FormControl type="text" value={task.title} className="form-control" onChange={(event) => this.taskChange('title',event)}/></Col>
            </FormGroup>
            <FormGroup>
              <Col sm={2} componentClass={ControlLabel}>Projet*: </Col>
              <Col sm={4}>
                <Select.Creatable
                  closeOnSelect={true}
                  disabled={false}
                  onChange={(value) => this.taskSelectChange('projectId', value)}
                  onNewOptionClick={(option) => this.newProject(option)}
                  promptTextCreator={(label) => "Créer le projet « " + label + " »"}
                  showNewOptionAtTop={false}
                  options={soPlanningProjects}
                  value={task.projectId}
                />
              </Col>
              <Col sm={2} componentClass={ControlLabel}>Intervenant*:</Col>
              <Col sm={4}>
                <Select.Creatable
                  closeOnSelect={true}
                  disabled={false}
                  onChange={(value) => this.taskSelectChange('userId', value)}
                  options={soPlanningUsers}
                  value={task.userId}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={2} componentClass={ControlLabel}>Autres intervenants:</Col>
              <Col sm={10}>
                <Select
                  multi={true}
                  closeOnSelect={false}
                  placeholder="Aucun — ajouter un ou plusieurs intervenants (une tâche liée chacun dans le planning)"
                  noResultsText="Aucun intervenant"
                  onChange={(vals) => this.extraChange(vals)}
                  options={soPlanningUsers.filter((u) => String(u.value).toLowerCase() !== String(task.userId || "").toLowerCase())}
                  value={this.extrasShown()}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={2} componentClass={ControlLabel}>Début*: </Col>
              <Col sm={2}>
                <FormControl
                  type="date"
                  className="form-control" 
                  value={task.startDate}
                  onChange={(value) => this.taskChange('startDate', value)}
                />
              </Col>
              <Col sm={2} componentClass={ControlLabel}>Fin: </Col>
              <Col sm={2}>
              <FormControl
                  type="date"
                  className="form-control" 
                  value={task.endDate}
                  onChange={(value) => this.taskChange('endDate', value)}
                />
              </Col>
            </FormGroup>
          </div>) : null }
        {request.predictedAt === null || updateResponse || showPlanningModal ? (
          <PlanningGrid
            users={soPlanningUsers}
            projects={soPlanningProjects}
            selUserId={task.userId}
            selStart={task.startDate}
            selEnd={task.endDate}
            selTitle={task.title}
            requestId={request.id}
            readOnly={!canUpdate || !(request.predictedAt === null || updateResponse)}
            onPick={this.pickFromGrid}
            selExtraIds={this.extrasShown()}
            onToggleExtra={this.toggleExtra}
          />
        ) : null}
        {this.state.xMsg ? (
          <div className={"alert " + (this.state.xMsg.ok ? "alert-info" : "alert-warning")} style={{ padding: "6px 12px", marginBottom: 10 }}>{this.state.xMsg.t}</div>
        ) : null}
        <Row>
          <Col sm={this.validateResponse() ? 9 : 12}>
            <textarea
              rows="8"
              className="form-control note-editor"
              disabled={!canUpdate || !this.validateResponse()}
              value={getStrValue(this.state.responseResume)}
              onChange={this.inputResponseChangeHandler}
            />
          </Col>
          {this.validateResponse() ? (
          <Col sm={3}>
            <UploadZone setFiles={(values) => this.setFiles(values)} />
            </Col>
          ) : null}
        </Row>
        {canUpdate && interventionDate === null ? (
        <Button
            bsClass="btn btn-block btn-primary mt-lg"
            onClick={(event) => this.predictRequestHandler(event)}
            disabled={!this.validateResponse()}
          >
            <span className="fa fa-mail-reply" />{" "}
            {null !== this.state.predictedDate ? "(Re)" : ""} Plannifier
        </Button>
          
        ) : null}
      
        { (notify) ? (<Notification message={message} toastId={1}  notificationType={notificationType} />) : null}
      </Form>

    
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Request/Tab/PlanedTab.js